import React, { useCallback, useMemo } from 'react';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { DeleteOutlined } from '@ant-design/icons';

import sortByString, { safeExtractFromObject } from '../../helpers/helpers';
import BorderlessButton from '../../common/buttons/BorderlessButton';
import colors from '../../constants/Colors';

const columns = (onRemove) => [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '',
    key: 'action',
    width: 80,
    render: (_, record) => (
      <BorderlessButton
        iconNode={<DeleteOutlined style={{ color: colors.ONTRACCR_RED }} />}
        onClick={() => onRemove(record.id)}
      />
    ),
  },
];

export default function OTProfileAssignmentTable({ data = [], onRemove }) {
  const settings = useSelector((state) => safeExtractFromObject(state, 'settings.company.settings'));

  const tableColumns = columns(onRemove);
  const sortedData = useMemo(() => (
    (data || []).filter((item) => !!item).sort(sortByString('name'))
  ), [data]);

  const onHeaderRow = useCallback(() => {
    if (!settings?.uxRedesignPt1) return null;
    return { className: 'ontraccr-table-header' };
  }, [settings]);

  return (
    <Table
      size="small"
      pagination={false}
      columns={tableColumns}
      dataSource={sortedData}
      rowKey="id"
      onHeaderRow={onHeaderRow}
    />
  );
}

OTProfileAssignmentTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
  onRemove: PropTypes.func.isRequired,
};

OTProfileAssignmentTable.defaultProps = {
  data: [],
};
